import httpClient from './httpClient'
import { bffURL } from '../config'

export default class AdditionalSteps {
  static async getWotcWithToken (postingId, idToken) {
    return await httpClient.get(`${bffURL}/postings/wotc/postings/${postingId}/initiate-screening?channel=trapply`, idToken)
  }
}
